import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KnBrConsentManagementService {
  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService
  ) {}
  setConsentAcceptedTrue(userId: string): Observable<any> {
    // Using OCC endpoints service so that baseUrl/prefix/site are applied.
    const url = this.occEndpoints.buildUrl(`users/${userId}/consent`);
    return this.http.post(url, { consentAccepted: true });
  }

}